import heroImage from "@/assets/hero-castles.webp";
import { heroConfig } from "@/config/heroConfig";
import { HeroButtons } from "@/components/hero/HeroButtons";
import { HeroStats } from "@/components/hero/HeroStats";
import { HeroFeatureCards } from "@/components/hero/HeroFeatureCards";
import { FloatingElements } from "@/components/hero/FloatingElements";
export const Hero = () => {
  return <section id="accueil" className="relative pt-16 min-h-screen flex items-center overflow-hidden">
      {/* Background with gradient overlay */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `url(${heroImage})`
    }} role="img" aria-label="Châteaux gonflables dans un jardin coloré">
        <div className="absolute inset-0 bg-gradient-to-r from-primary/90 via-primary/70 to-secondary/80" />
      </div>

      {/* Floating decorative elements - deferred to avoid blocking LCP */}
      <FloatingElements />

      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          
          {/* Hero Content */}
          <div className="flex-1 text-center lg:text-left">
            
            <h1 className="text-3xl xs:text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-display font-bold text-white mb-6 leading-tight will-change-auto">
              {heroConfig.title.main}
              <span className="bg-gradient-to-r from-accent to-accent-light bg-clip-text text-transparent mx-[10px]">
                {heroConfig.title.highlight}
              </span>
            </h1>
            
            <p className="text-lg xs:text-xl md:text-2xl text-white/90 mb-8 leading-relaxed max-w-2xl mx-auto lg:mx-0">
              {heroConfig.description}
            </p>

            <HeroButtons config={heroConfig.buttons} />

            {/* Quick stats */}
            <HeroStats stats={heroConfig.stats} />
          </div>

          {/* Hero Features Cards */}
          <HeroFeatureCards features={heroConfig.features} />
        </div>
      </div>
    </section>;
};